import { useState, useCallback } from 'react';
import { setExamDetails } from '../redux/states';

// Shared hook to gate exam start behind a confirmation modal
// Usage:
// const { examReady, handleOngoing, handleDoneEvent, confirmStartExam, closeGate } = useExamStartGate(navigate, dispatch, '/user/dashboard/mock/exam-started');
export default function useExamStartGate(navigate, dispatch, startPath = '/user/dashboard/mock/exam-started') {
  const [examReady, setExamReady] = useState(false);
  const [pendingExamDetails, setPendingExamDetails] = useState(null);

  const openWithDetails = useCallback((details) => {
    setPendingExamDetails(details);
    setExamReady(true);
  }, []);

  const handleOngoing = useCallback((details) => {
    // Exam already exists; store and open gate
    openWithDetails(details);
  }, [openWithDetails]);

  const handleDoneEvent = useCallback((e) => {
    // Parse SSE done payload and open gate
    const examDetails = JSON.parse(e.data);
    openWithDetails(examDetails);
    return examDetails;
  }, [openWithDetails]);

  const confirmStartExam = useCallback(() => {
    if (!pendingExamDetails) return;
    dispatch(setExamDetails(pendingExamDetails));
    setExamReady(false);
    navigate(startPath);
  }, [pendingExamDetails, dispatch, navigate, startPath]);

  const closeGate = useCallback(() => setExamReady(false), []);

  return {
    examReady,
    pendingExamDetails,
    handleOngoing,
    handleDoneEvent,
    confirmStartExam,
    closeGate,
  };
}
